export * from './map.component';